import { useState, useCallback } from "react";
import {
  createEventLocation,
  updateEventLocation,
  deleteEventLocation,
  type CreateEventLocationInput,
  type UpdateEventLocationInput,
} from "../services/eventLocationService";

export function useCreateEventLocation() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const create = useCallback(async (input: CreateEventLocationInput) => {
    setLoading(true);
    setError(null);
    try {
      const id = await createEventLocation(input);
      return id;
    } catch (err) {
      const e =
        err instanceof Error ? err : new Error("Create location failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { create, loading, error };
}

export function useUpdateEventLocation() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const update = useCallback(
    async (locationId: string, input: UpdateEventLocationInput) => {
      setLoading(true);
      setError(null);
      try {
        await updateEventLocation(locationId, input);
      } catch (err) {
        const e =
          err instanceof Error ? err : new Error("Update location failed");
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { update, loading, error };
}

export function useDeleteEventLocation() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const remove = useCallback(async (locationId: string) => {
    setLoading(true);
    setError(null);
    try {
      await deleteEventLocation(locationId);
    } catch (err) {
      const e =
        err instanceof Error ? err : new Error("Delete location failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { remove, loading, error };
}
